/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { Link } from 'gatsby';
import { token } from '@atlaskit/tokens';
import { N0, N300, N50A, N60A } from '@atlaskit/theme/colors';
import type { ReactNode } from 'react';

const linkStyles = css({
  textDecoration: 'none !important',
  '&:focus-visible': {
    borderRadius: '3px',
  },
});

const cardStyles = css({
  height: '100%',
  borderRadius: '3px',
  background: token('elevation.surface.raised', N0),
  color: token('color.text.subtlest', N300),
  boxShadow: token(
    'elevation.shadow.raised',
    `0 1px 1px ${N50A}, 0 0 1px 0 ${N60A}`,
  ),
  '&:hover': {
    boxShadow: token(
      'elevation.shadow.overlay',
      `0 8px 16px -4px ${N50A}, 0 0 1px ${N60A}`,
    ),
  },
});

interface CardLinkProps {
  to: string;
  children: ReactNode;
}

const CardLink = ({ to, children }: CardLinkProps) => {
  return (
    <Link css={linkStyles} to={to}>
      <div css={cardStyles}>{children}</div>
    </Link>
  );
};

export default CardLink;
